<template lang="pug">
    .scene.scene_final
        .scene_final--x-wrap
            .scene_final--x
                img.left(src="/static/images/x_l.svg", alt="")
                img.main(src="/static/images/x.svg", alt="")
                img.right(src="/static/images/x_r.svg", alt="")
        a.sharebtn.scene--btn.scene_final--btn.scene_final--share(@click.prevent="share()", v-audioHover="", href="https://www.facebook.com/sharer.php?u=http://tenyear.sointeractive.co.za")
            span Share
        a.scene--btn.scene_final--btn.scene_final--replay(v-audioHover="", href="javascript:;", @click="reverse()")
            span Replay
        a.by_so_interactive(href="http://sointeractive.co.za/", target="_blank")
            span 10 years of digital experiences
            img.logo(src="/static/images/so_logo.png", alt="")
</template>
<script>
let tl = new TimelineMax({})
export default {
    mounted() {
        this.$store.commit('anatomy', false)
        this.animation()
    },
    methods: {
        reverse() {
            tl.to('.scene_final', 3, { opacity: 0, ease: Power4.easeOut, onComplete: () => {
                this.$router.push({name: 'Home'})
            } })
        },
        animation() {
            let self = this
            tl
                .fromTo('.scene_final', 3, { opacity: 0, ease: Power4.easeOut }, { opacity: 1 })
                .from('.scene--btn', 1, { width: 0, opacity: 0, ease:Power2.easeOut }, '-=0.5')
                .from('.scene--btn span', 1, { y: '120%', opacity: 1, ease: Power2.easeOut })
        },
        share(intWidth, intHeight, blnResize) {
            // Set values for window
            var intWidth = intWidth || '600';
            var intHeight = intHeight || '400';
            var strResize = (blnResize ? 'yes' : 'no');

            let self = event.target

            // Set title and open popup with focus on it
            var strTitle = ((typeof self.getAttribute('title') !== 'undefined') ? self.getAttribute('title') : 'Social Share'),
                strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
                objWindow = window.open(self.getAttribute('href'), strTitle, strParam).focus()
        }
    },
    beforeDestroy() {
        tl.kill()
    },
}
</script>
<style lang="scss">
.scene.scene_final {
    display: flex; opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/final.vue